/* eslint-disable linebreak-style */
import styled from 'styled-components'

export const Button = styled.button`
  width: 100%;
  background-color: #FF9F0A;
  text-align: center;
  color: #000000; 
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  font-size: 24px;
  padding: 10px;
  cursor: pointer;
  border: none;
  border-radius: 20px;
`